import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAllTemplates(oauthTokenHeader: string, website_shared_uid: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/design/templates/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader
  );
}

function createTemplate(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/asset_management/design/templates/`,
    data,
    oauthTokenHeader
  );
}

/**
 * `dateRange` is optional and scopes the `revisions` in the response. Existing
 * callers that omit it keep the previous, unfiltered behaviour.
 */
function getSingleTemplate(
  oauthTokenHeader: string,
  template_shared_uid: string,
  dateRange?: { startDate: string; endDate: string }
) {
  const query = dateRange
    ? `?start_date=${encodeURIComponent(
        dateRange.startDate
      )}&end_date=${encodeURIComponent(dateRange.endDate)}`
    : "";

  return fetchWrapper.get(
    `${apiUrl}/asset_management/design/templates/${template_shared_uid}/${query}`,
    oauthTokenHeader
  );
}

/**
 * Same resource as `getSingleTemplate`, but returns the template as it stood at
 * the given revision. Used by the Edit screen's revision history.
 */
function getTemplateRevision(
  oauthTokenHeader: string,
  template_shared_uid: string,
  revision_id: string
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/design/templates/${template_shared_uid}/?revision=${revision_id}`,
    oauthTokenHeader
  );
}

function editTemplate(
  oauthTokenHeader: string,
  data: any,
  template_shared_uid: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/design/templates/${template_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function getWidgetStructure(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/widgets_structure`, oauthTokenHeader);
  }
  function getLabels(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/utilities/labels/`, oauthTokenHeader);
  }

export const templateService = {
  getAllTemplates,
  createTemplate,
  getSingleTemplate,
  getTemplateRevision,
  editTemplate,
  getWidgetStructure,
  getLabels
};